import Vue from 'vue';
import Buefy from 'buefy';
import * as VueGoogleMaps from 'vue2-google-maps';
import GmapCluster from 'vue2-google-maps/dist/components/cluster';
import VueMeta from 'vue-meta';
import JsonCSV from 'vue-json-csv';
import App from './App.vue';
import router from './router';
import store from './store/store';
import './assets/scss/app.scss';

Vue.use(Buefy);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCv-YvtnpWFMggWL7BoyahVNxgVPZA9qsE',
    libraries: 'places',
  },
});
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
});
Vue.component('GmapCluster', GmapCluster);
Vue.component('downloadCsv', JsonCSV);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
